export enum CopilotStepStatusEnum {
  DONE = "done",
  RUNNING = "running",
  PENDING = "pending",
  ERROR = "error",
}

/** State of a field extracted from the document — wire values of the `data-recap` fields. */
export enum CopilotFieldStateEnum {
  EXTRACTED = "extracted",
  MISSING = "missing",
}

/** Step identifiers the backend sends during a `reviewTraining` workflow. */
export enum CopilotReviewStepEnum {
  READ_PROGRAM = "read_program",
  EXTRACT_PROGRAM = "extract_program",
  MATCH_TRAINING = "match_training",
  BUILD_REVIEW = "build_review",
}

/** Step identifiers the backend sends during a `declareAttendance` workflow. */
export enum CopilotAttendanceStepEnum {
  UNDERSTAND_REQUEST = "understand_request",
  ANALYZE_SIGN_IN_SHEET = "analyze_sign_in_sheet",
  FIND_SESSION = "find_session",
}

/**
 * Which workflow a `data-recap` part summarises. Absent on the training import, which is the
 * recap the block was written for — so only the attendance one has to announce itself.
 */
export enum CopilotRecapSourceEnum {
  ATTENDANCE = "attendance",
}
